import { useSetAtom } from "jotai";
import { API_NAME_RECORDS } from "../constants/api";
import { nameResultsAtom } from "../store/store";
import { useFetch } from "./useFetch";
import { useGetUnlockedNames } from "./useGetUnlockedNames";
import { NameOptions, NameResult, Option } from "../types";

interface RecordItem
  extends Omit<NameResult, "styles" | "themes" | "meanings" | "phonetics"> {
  options: Record<keyof Omit<NameOptions, "length">, Option[]>;
}

export function useAfterLogin() {
  const setResults = useSetAtom(nameResultsAtom);
  const { getUnlockedNames } = useGetUnlockedNames();
  const { request } = useFetch();

  const getNameRecords = async () => {
    try {
      const {
        data: { records },
      } = await request<{ records: RecordItem[] }>(API_NAME_RECORDS, {
        method: "GET",
      });
      setResults(
        records.map((item) => ({
          ...item,
          options: undefined,
          styles: item.options.styles,
          themes: item.options.themes,
          meanings: item.options.meanings,
          phonetics: item.options.phonetics,
        }))
      );
    } catch (error) {}
  };

  const afterLogin = () => {
    getNameRecords();
    getUnlockedNames();
  };

  return { afterLogin };
}
